import PropTypes from 'prop-types';
import PlaylistCard from '../../components/PlaylistCard';
import DiagnosticCard from '../../components/DiagnosticCard';
import { Core } from '@everfi/reactifi';

const PlaylistCardContainer = ({ program, playlistLimit, renderAsLegacy }) => {
  const playlistItems = () => {
    return program.playlists.slice(0, playlistLimit).map(playlist => {
      const genericIncentive = program.incentives.find(incentive => incentive.playlist_id === playlist.id);
      return (
        <PlaylistCard
          genericIncentive={genericIncentive}
          key={playlist.id}
          playlist={playlist}
          program={program}
          learnerDahsboard={false}
          renderAsLegacy={renderAsLegacy}
        />
      );
    });
  };

  const diagnosticItems = () => {
    return program.diagnostics.slice(0, playlistLimit).map(diagnostic => {
      const genericIncentive = program.incentives.find(incentive => incentive.diagnostic_id === diagnostic.id);
      return (
        <DiagnosticCard
          key={diagnostic.id}
          program={program}
          diagnostic={diagnostic}
          genericIncentive={genericIncentive}
          learnerDahsboard={false}
          renderAsLegacy={renderAsLegacy}
        />
      );
    });
  };

  return (
    <div className="other-playlists">
      <Core.Layout variant="grid" gridTemplateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gridGap={6}>
        {playlistItems()}
        {diagnosticItems()}
      </Core.Layout>
    </div>
  );
};

PlaylistCardContainer.propTypes = {
  program: PropTypes.object,
  playlistLimit: PropTypes.number,
  renderAsLegacy: PropTypes.bool,
};

export default PlaylistCardContainer;
